<mat-toolbar class="topbar mat-bg-card">
  <!-- Sidenav toggle button -->
  @if (layoutConf.sidebarStyle !== 'compact') {
    <button mat-icon-button id="sidenavToggle" (click)="toggleSidenav()"
      matTooltip="Toggle Hide/Open">
      <mat-icon>menu</mat-icon>
    </button>
  }

  <!-- App search -->
  <sca-app-search></sca-app-search>

  <!-- Online Help Link -->
  <a href="http://sab.is/DBY6RZ" target="_blank" rel="noopener" class="help-link" matTooltip="Online Help">
    <span class="material-symbols-outlined">
      help
    </span>
  </a>
  <span class="splitter"></span>

  <!-- Notification toggle button (hidden for administrators for now) -->
  @if (!showNotifications) {
    <span>&nbsp;</span>
  }
  @if (showNotifications) {
    <button mat-icon-button matTooltip="Notifications" (click)="toggleNotific()"
      class="topbar-button-right">
      <mat-icon>notifications</mat-icon>
      @if (notificationsService.unreadNotificationsCount() > 0) {
        <span class="notification-number mat-bg-warn">
          {{ notificationsService.unreadNotificationsCount() }}
        </span>
      }
    </button>
  }

  @if (username) {
    <span class="username">{{ username }}</span>
  }

  <!-- Top left user menu -->
  <button class="user-button" [matMenuTriggerFor]="accountMenu">
    <!--<img src="assets/images/face-7.jpg" alt="" />-->
    <span class="profile-initials">
      <mat-icon>person</mat-icon>
      {{ initials }}
    </span>

  </button>

  <mat-menu #accountMenu="matMenu">
    @if (false) {
      <button mat-menu-item [routerLink]="['/profile/overview']">
        <mat-icon>account_box</mat-icon>
        <span>Profile</span>
      </button>

      <button mat-menu-item [routerLink]="['/profile/settings']">
        <mat-icon>settings</mat-icon>
        <span>Account Settings</span>
      </button>

      <button mat-menu-item>
        <mat-icon>notifications_off</mat-icon>
        <span>Disable alerts</span>
      </button>
    }

    <button mat-menu-item (click)="logout()">
      <mat-icon>logout</mat-icon>
      <span>Sign out</span>
    </button>

  </mat-menu>
</mat-toolbar>
